import { Observable } from 'rxjs';
import { IModelEntity, IBaseService } from '@pit/core';

export interface QueryParams {
    [name: string]: any | any[];
}

export interface RequestParams {

    startRow?: number | null;
    rowsToTake?: number | null;

    query?: string | null;
    transactionId?: string | null;
    urlParams?: string[] | null;
    queryParams?: QueryParams | null;

}

export interface IListResult<T extends IModelEntity> {

    count: number;
    items: T[];

}

export interface IPagingInfo {

    offset: number;
    limit: number;

}

export enum StorageType {

    Local = 0,
    Remote = 1

}

export interface IEntityDataService<T extends IModelEntity> extends IBaseService {

    delete$: (entity: T, storageType?: StorageType) => Observable<any>;
    getAll$: (storageType?: StorageType) => Observable<T[]>;
    getAllWithPaging$: (startRow: number, rowsToTake?: number) => Observable<IListResult<T>>;
    getById$: (id: number, storageType?: StorageType) => Observable<T>;
    getByQuery$: (requestParams: RequestParams) => Observable<IListResult<T>>;
    save$: (entity: T, storageType?: StorageType) => Observable<T>;
    saveMulti$: (entities: T[]) => Observable<boolean>;

    deleteAsync: (entity: T, storageType?: StorageType) => Promise<any>;
    getAllAsync: (storageType?: StorageType) => Promise<T[]>;
    getAllWithPagingAsync: (startRow: number, rowsToTake?: number) => Promise<IListResult<T>>;
    getByIdAsync: (id: number, storageType?: StorageType) => Promise<T>;
    getByQueryAsync: (requestParams: RequestParams) => Promise<IListResult<T>>;
    saveAsync: (entity: T, storageType?: StorageType) => Promise<T>;
    saveMultiAsync: (entities: T[]) => Promise<boolean>;

}
